// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */

import {Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Progress} from "reactstrap";
import React from "react";
import type {Caller} from "../QueryPage";

export type ActivateUserModalStateProps = {
    open: boolean,
    ssoUid?: string,
    email: string,
    caller: Caller,
    isLoading: boolean,
    error?: any
}

export type ActivateUserModalDispatchProps = {

    activateUser: (ssoUid: string, caller: Caller) => any,
    closeModal: () => any
}

type ActivateUserModalProps = ActivateUserModalStateProps & ActivateUserModalDispatchProps;

export default function ActivateUserModal(props: ActivateUserModalProps) {


    return (
        <Modal isOpen={props.open} toggle={() => {

            if (!props.isLoading) {
                props.closeModal();
            }
        }}>
            <ModalHeader toggle={() => {
                if (!props.isLoading) {

                    props.closeModal();
                }
            }}>Warning</ModalHeader>
            <ModalBody>
                {
                    !props.isLoading && !props.error &&
                    <span>You should Resend Activation Email to user first. If already sent, are you sure to activate {props.email}?</span>
                }
                {
                    !props.isLoading && props.error &&
                    <Alert color={"danger"}>Failed. Please try again!</Alert>
                }
                {
                    props.isLoading &&
                    <span>OK. We are activating..</span>
                }

                {
                    props.isLoading &&

                    (<Progress animated color="danger" value="100" />)
                }
            </ModalBody>
            <ModalFooter>
                {
                    !props.isLoading && !props.error &&

                    [<Button key={1} color="danger" onClick={() => {
                        if (typeof props.ssoUid !== 'undefined') {

                                props.activateUser(props.ssoUid, props.caller);
                        }
                    }}>Activate</Button>,
                        <Button key={2} color="secondary" onClick={() => {

                            if (!props.isLoading) {
                                props.closeModal();
                            }
                        }}>Cancel</Button>]
                }

            </ModalFooter>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/components/sso/ActivateUserModal.js